import useCheckPC from "@repo/hooks/utils/useCheckPC";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import useMeta from "@hooks/reducerHooks/useMeta";

function TermsConditions() {
  const { isPC } = useCheckPC();
  const { setMetaTag } = useMeta();

  const { t } = useTranslation();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - TERMS AND CONDITIONS` });
  }, []);

  return (
    <section className="tune-column-4 leading-relax">
      <div className={classNames("grid grid-cols-1 gap-x-5", isPC && "col-span-6 col-start-4 max-w-2xl")}>
        <div className="flex flex-col gap-[20px]">
          <span>{t("pages.terms_and_conditions.title")}</span>
          <div>
            <p className="whitespace-pre-line">{t("pages.terms_and_conditions.description")}</p>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article1.title")}</strong>
            </p>
            <p className="whitespace-pre-line">{t("pages.terms_and_conditions.article1.information")}</p>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article2.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article2.information1")}</li>
              <li>{t("pages.terms_and_conditions.article2.information2")}</li>
              <li>{t("pages.terms_and_conditions.article2.information3")}</li>
              <li>{t("pages.terms_and_conditions.article2.information4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article3.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article3.information1")}</li>
              <li>{t("pages.terms_and_conditions.article3.information2")}</li>
              <li>{t("pages.terms_and_conditions.article3.information3")}</li>
              <li>{t("pages.terms_and_conditions.article3.information4")}</li>
              <li>{t("pages.terms_and_conditions.article3.information5")}</li>
              <li>{t("pages.terms_and_conditions.article3.information6")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article4.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>
                {t("pages.terms_and_conditions.article4.description")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article4.subDescription1")}</li>
                  <li>{t("pages.terms_and_conditions.article4.subDescription2")}</li>
                  <li>{t("pages.terms_and_conditions.article4.subDescription3")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article4.information1")}</li>
              <li>{t("pages.terms_and_conditions.article4.information2")}</li>
              <li>{t("pages.terms_and_conditions.article4.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article5.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article5.information1")}</li>
              <li>{t("pages.terms_and_conditions.article5.information2")}</li>
              <li>{t("pages.terms_and_conditions.article5.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article6.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article6.information1")}</li>
              <li>
                {t("pages.terms_and_conditions.article6.information2")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article6.subInformation1")}</li>
                  <li>{t("pages.terms_and_conditions.article6.subInformation2")}</li>
                  <li>{t("pages.terms_and_conditions.article6.subInformation3")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article6.information3")}</li>
              <li>{t("pages.terms_and_conditions.article6.information4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article7.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article7.information1")}</li>
              <li>
                {t("pages.terms_and_conditions.article7.information2")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article7.subInformation1")}</li>
                  <li>{t("pages.terms_and_conditions.article7.subInformation2")}</li>
                  <li>{t("pages.terms_and_conditions.article7.subInformation3")}</li>
                  <li>{t("pages.terms_and_conditions.article7.subInformation4")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article7.information3")}</li>
              <li>{t("pages.terms_and_conditions.article7.information4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article8.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article8.information1")}</li>
              <li>{t("pages.terms_and_conditions.article8.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article9.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>
                {t("pages.terms_and_conditions.article9.information1")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article9.subInformation1")}</li>
                  <li>{t("pages.terms_and_conditions.article9.subInformation2")}</li>
                  <li>{t("pages.terms_and_conditions.article9.subInformation3")}</li>
                  <li>{t("pages.terms_and_conditions.article9.subInformation4")}</li>
                  <li>{t("pages.terms_and_conditions.article9.subInformation5")}</li>
                  <li>{t("pages.terms_and_conditions.article9.subInformation6")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article9.information2")}</li>
              <li>{t("pages.terms_and_conditions.article9.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article10.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>
                {t("pages.terms_and_conditions.article10.information1")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article10.subInformation1")}</li>
                  <li>{t("pages.terms_and_conditions.article10.subInformation2")}</li>
                  <li>{t("pages.terms_and_conditions.article10.subInformation3")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article10.information2")}</li>
              <li>{t("pages.terms_and_conditions.article10.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article11.title")}</strong>
            </p>
            <p>{t("pages.terms_and_conditions.article11.description")}</p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article11.information1")}</li>
              <li>{t("pages.terms_and_conditions.article11.information2")}</li>
              <li>{t("pages.terms_and_conditions.article11.information3")}</li>
              <li>{t("pages.terms_and_conditions.article11.information4")}</li>
              <li>{t("pages.terms_and_conditions.article11.information5")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article12.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article12.information1")}</li>
              <li>{t("pages.terms_and_conditions.article12.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article13.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article13.information1")}</li>
              <li>{t("pages.terms_and_conditions.article13.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article14.title")}</strong>
            </p>
            <p>{t("pages.terms_and_conditions.article14.information1")}</p>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article15.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article15.information1")}</li>
              <li>
                {t("pages.terms_and_conditions.article15.information2")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.article15.subInformation1")}</li>
                  <li>{t("pages.terms_and_conditions.article15.subInformation2")}</li>
                  <li>{t("pages.terms_and_conditions.article15.subInformation3")}</li>
                  <li>{t("pages.terms_and_conditions.article15.subInformation4")}</li>
                  <li>{t("pages.terms_and_conditions.article15.subInformation5")}</li>
                </ul>
              </li>
              <li>{t("pages.terms_and_conditions.article15.information3")}</li>
              <li>{t("pages.terms_and_conditions.article15.information4")}</li>
              <li>{t("pages.terms_and_conditions.article15.information5")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article16.title")}</strong>
            </p>
            <ul className="list-outside list-[hangul] pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article16.information1")}</li>
              <li>{t("pages.terms_and_conditions.article16.information2")}</li>
              <li>{t("pages.terms_and_conditions.article16.information3")}</li>
              <li>{t("pages.terms_and_conditions.article16.information4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article17.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article17.information1")}</li>
              <li>{t("pages.terms_and_conditions.article17.information2")}</li>
              <li>{t("pages.terms_and_conditions.article17.information3")}</li>
              <li>{t("pages.terms_and_conditions.article17.information4")}</li>
              <li>{t("pages.terms_and_conditions.article17.information5")}</li>
              <li>{t("pages.terms_and_conditions.article17.information6")}</li>
              <li>{t("pages.terms_and_conditions.article17.information7")}</li>
              <li>{t("pages.terms_and_conditions.article17.information8")}</li>
              <li>{t("pages.terms_and_conditions.article17.information9")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article18.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article18.information1")}</li>
              <li>{t("pages.terms_and_conditions.article18.information2")}</li>
              <li>{t("pages.terms_and_conditions.article18.information3")}</li>
              <li>{t("pages.terms_and_conditions.article18.information4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article19.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article19.information1")}</li>
              <li>{t("pages.terms_and_conditions.article19.information2")}</li>
              <li>{t("pages.terms_and_conditions.article19.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article20.title")}</strong>
            </p>
            <p>{t("pages.terms_and_conditions.article20.description")}</p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article20.information1")}</li>
              <li>{t("pages.terms_and_conditions.article20.information2")}</li>
              <li>{t("pages.terms_and_conditions.article20.information3")}</li>
              <li>{t("pages.terms_and_conditions.article20.information4")}</li>
              <li>{t("pages.terms_and_conditions.article20.information5")}</li>
              <li>{t("pages.terms_and_conditions.article20.information6")}</li>
              <li>{t("pages.terms_and_conditions.article20.information7")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article21.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article21.information1")}</li>
              <li>{t("pages.terms_and_conditions.article21.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article22.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article22.information1")}</li>
              <li>{t("pages.terms_and_conditions.article22.information2")}</li>
              <li>{t("pages.terms_and_conditions.article22.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article23.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article23.information1")}</li>
              <li>{t("pages.terms_and_conditions.article23.information2")}</li>
              <li>{t("pages.terms_and_conditions.article23.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.article24.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.terms_and_conditions.article24.information1")}</li>
              <li>{t("pages.terms_and_conditions.article24.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.terms_and_conditions.special_terms_and_conditions.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>
                {t("pages.terms_and_conditions.special_terms_and_conditions.no_purchases.title")}
                <br />
                {t("pages.terms_and_conditions.special_terms_and_conditions.no_purchases.description")}
              </li>
              <li>
                {t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.title")}
                <br />
                {t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.description1")}
                <ul className="list-outside list-[hangul] pb-1 pl-6">
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information1")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information2")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information3")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information4")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information5")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information6")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information7")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information8")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information9")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information10")}</li>
                  <li>{t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.information11")}</li>
                </ul>
                {t("pages.terms_and_conditions.special_terms_and_conditions.right_to_Refuse.description2")}
              </li>
              <li>
                {t("pages.terms_and_conditions.special_terms_and_conditions.risk_of_loss.title")}
                <br />
                {t("pages.terms_and_conditions.special_terms_and_conditions.risk_of_loss.description")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsConditions;
